import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-multiple-vessel-creation',
  templateUrl: './multiple-vessel-creation.component.html',
  styleUrls: ['./multiple-vessel-creation.component.scss']
})
export class MultipleVesselCreationComponent {
vesselCreationForm: FormGroup;
  isEditMode = false;
  displayedColumns: string[] = ['sno', 'field_name', 'data_type', 'is_mandatory', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  displayDropDownDataColumn: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<MultipleVesselCreationComponent>,
    @Inject(MAT_DIALOG_DATA) public existingdata: any
  ) {
    this.isEditMode = !!existingdata?.isEditMode;
    const initialData = existingdata?.vessels || [existingdata].filter(Boolean);
    this.vesselCreationForm = this.fb.group({
      vessels: this.fb.array(
        initialData.length > 0
          ? initialData.map((vessel: any) => this.createVesselGroup(vessel))
          : [this.createVesselGroup()]
      )
    });
    this.updateDataSource();
  }

  get vesselsArray() {
    return this.vesselCreationForm.get('vessels') as FormArray;
  }

  createVesselGroup(vessel?: any): FormGroup {
    return this.fb.group({
      field_name: [vessel?.field_name || '', Validators.required],
      data_type: [vessel?.data_type || '', Validators.required],
      is_mandatory: [vessel?.is_mandatory, Validators.required],
      showDropDownField: [vessel?.data_type === 'select' || false],
      dropdown_input: [vessel?.dropdown_input || '', vessel?.data_type === 'select' ? Validators.required : []]
    });
  }

  updateDataSource(): void {
    this.dataSource.data = this.vesselsArray.controls.map((control, index) => ({ index, control }));
  }

  addVesselRow(): void {
    this.vesselsArray.push(this.createVesselGroup());
    this.updateDataSource();
  }

  removeVesselRow(index: number): void {
    if (this.vesselsArray.length > 1) {
      this.vesselsArray.removeAt(index);
      this.updateDataSource();
    }
  }

  saveVessels(): void {
    if (this.vesselCreationForm.valid) {
      this.dialogRef.close(this.vesselsArray.value);
    } else {
      this.vesselCreationForm.markAllAsTouched();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }


  onDataTypeSelect(event: any, element: any): void {
    const control = element.control;
    if (event.value === 'select') {
      control.get('showDropDownField')?.setValue(true);
    }
    else {
      control.get('showDropDownField')?.setValue(false);
    }
  }
}
